(() => {
  'use strict';
  if (window.CarOptionsVwScreen) { window.CarOptionsVwScreen.initialize(document); return; }
  const clamp = (value, min = 0, max = 1) => Math.min(max, Math.max(min, value));
  const isPoloAw = selection => selection?.profile.id === 'vw-polo-aw-colour-65' && selection?.choice.modelKey === 'vw-polo';
  const baseSteps = [
    { at: 0, stop: 0, id: 'original', title: 'Van radio naar CarPlay.', body: 'Je vertrouwde dashboard, met een nieuw scherm voor je telefoon.' },
    { at: .025, stop: .445, id: 'old-radio-out', title: 'Oude radio eruit.', body: 'Maak de omlijsting en vier schroeven los. Trek de radio naar voren en koppel de stekkers los.' },
    { at: .505, stop: .644, id: 'connect-new', title: 'Nieuwe radio aansluiten.', body: 'Sluit de hoofdstekker en antenne aan met de aansluitset voor jouw auto.' },
    { at: .658, stop: 1, id: 'carplay', title: 'Klaar voor CarPlay.', body: 'Schuif de radio terug, zet alles vast en verbind je telefoon. Controleer daarna beeld en geluid.' }
  ];
  const stepAt = value => { let index = 0; baseSteps.forEach((step, i) => { if (value >= step.at) index = i; }); return index; };
  async function mount(root, pageData) {
    if (root.dataset.installMounted === 'true') return;
    root.dataset.installMounted = 'true';
    const doc = root.ownerDocument, win = doc.defaultView, q = selector => root.querySelector(selector);
    const steps = baseSteps.map(step => ({...step}));
    let activeSelection = null;
    const pin = q('[data-install-pin]'), stage = q('[data-install-stage]'), canvas = q('[data-install-canvas]');
    const headerSelector = '#shopify-section-header-inline [data-header-height], #shopify-section-header-inline .t4s-header__wrapper';
    const barSelector = '[data-sticky-addtocart], .t4s-sticky-atc';
    const buttons = [...root.querySelectorAll('[data-install-step]')], reduced = win.matchMedia('(prefers-reduced-motion: reduce)');
    const removers = [];
    let instance = null, visible = false, destroyed = false, loading = false, readySignal = false, generation = 0;
    let raf = 0, lastTick = null, observer = null, preloadObserver = null, resizeObserver = null, sizeDirty = true, lastWidth = 0, lastHeight = 0;
    let progress = 0, targetProgress = 0, currentStep = -1, announceIndex = null;
    const listen = (element, event, handler, options) => { if (!element) return; element.addEventListener(event, handler, options); removers.push(() => element.removeEventListener(event, handler, options)); };
    function setVariable(name, value) { if (root.style.getPropertyValue(name) !== value) root.style.setProperty(name, value); }
    function measureChrome() {
      const header = doc.querySelector(headerSelector), bar = doc.querySelector(barSelector);
      const headerRect = header?.getBoundingClientRect();
      const headerHeight = headerRect ? Math.max(0, Math.min(headerRect.height, headerRect.bottom)) : 0;
      const barStyle = bar ? win.getComputedStyle(bar) : null;
      const barRect = bar?.getBoundingClientRect();
      const barHeight = barRect && barStyle.position === 'fixed' && barStyle.display !== 'none' && barStyle.visibility !== 'hidden' && barRect.top < win.innerHeight && barRect.bottom > 0 ? Math.max(0, Math.min(barRect.height, win.innerHeight - barRect.top)) : 0;
      setVariable('--ci-header', Math.ceil(headerHeight) + 'px'); setVariable('--ci-bottom', Math.ceil(barHeight) + 'px');
    }
    const chromeTop = () => Number.parseFloat(root.style.getPropertyValue('--ci-header')) || 0;
    function updatePinPosition() {
      if (reduced.matches) { delete root.dataset.pinState; return; }
      const rect = root.getBoundingClientRect(), top = chromeTop();
      root.dataset.pinState = rect.top > top ? 'before' : rect.bottom <= top + pin.offsetHeight ? 'after' : 'pinned';
    }
    function fractionFromScroll() {
      const stickyTop = chromeTop();
      const value=clamp((stickyTop - root.getBoundingClientRect().top) / Math.max(1, root.offsetHeight - pin.offsetHeight));
      return value<.001?0:value>.999?1:value;
    }
    function updateCopy(value) {
      const index = stepAt(value), step = steps[index];
      root.dataset.progress = value.toFixed(5); root.dataset.targetProgress = targetProgress.toFixed(5); root.dataset.phase = step.id;
      stage.dataset.progress = value.toFixed(5); stage.dataset.phase = step.id;
      setVariable('--ci-progress', value.toFixed(5));
      q('[data-install-progress]').setAttribute('aria-valuenow', String(Math.round(value * 100)));
      if (index !== currentStep) {
        currentStep = index;
        q('[data-install-title]').textContent = step.title; q('[data-install-body]').textContent = step.body;
        canvas.setAttribute('aria-label', '3D-inbouwvisualisatie. Stap ' + (index + 1) + ' van 4: ' + step.title);
        q('[data-install-counter]').innerHTML = '0' + (index + 1) + ' <span>/ 04</span>';
        q('[data-install-progress]').setAttribute('aria-valuetext', 'Stap ' + (index + 1) + ' van 4: ' + step.title);
        buttons.forEach((button, i) => { button.setAttribute('aria-label', 'Stap ' + (i + 1) + ': ' + steps[i].title); button.setAttribute('aria-pressed', String(i === index)); button.dataset.complete = String(i < index); if (i === index) button.setAttribute('aria-current', 'step'); else button.removeAttribute('aria-current'); });
        q('[data-install-prev]').disabled = index === 0; q('[data-install-next]').disabled = index === steps.length - 1;
      }
      q('[data-install-hint]').textContent = reduced.matches ? 'Kies een stap' : 'Scroll verder';
      if (announceIndex === index) { announceIndex = null; q('[data-install-announcement]').textContent = 'Stap ' + (index + 1) + ' van 4. ' + step.title + ' ' + step.body; }
    }
    function releaseInstance() { if (!instance) return; const old = instance; instance = null; try { old.dispose(); } catch (_) {} }
    function failScene() {
      releaseInstance(); loading = false; readySignal = false; stage.dataset.state = 'error'; stage.setAttribute('aria-busy', 'false');
      q('[data-install-poster]').removeAttribute('aria-hidden');
      q('[data-install-load]').hidden = false; q('[data-install-status]').textContent = 'Het installatievoorbeeld is niet beschikbaar. Je kunt de vier stappen blijven lezen of het beeld opnieuw proberen.';
      q('[data-install-retry]').hidden = false; q('[data-install-retry]').disabled = false;
    }
    function markReady() {
      if (!instance || !readySignal || destroyed) return;
      q('[data-install-poster]').setAttribute('aria-hidden', 'true');
      loading = false; stage.dataset.state = 'ready'; stage.classList.remove('is-personal-loading'); stage.setAttribute('aria-busy', 'false'); q('[data-install-load]').hidden = true; q('[data-install-retry]').hidden = true; q('[data-install-status]').textContent = '';
      schedule();
    }
    function applySize() {
      if (!instance || !sizeDirty) return;
      sizeDirty = false;
      const rect = stage.getBoundingClientRect(), width = Math.max(1, Math.round(rect.width)), height = Math.max(1, Math.round(rect.height));
      if (width === lastWidth && height === lastHeight) return;
      lastWidth = width; lastHeight = height;
      // Renderer owns drawing-buffer size and pixel ratio. These are CSS pixels.
      instance.resize(width, height);
    }
    function draw() {
      updateCopy(progress);
      if (!instance) return;
      try { applySize(); instance.setProgress(progress); } catch (_) { failScene(); }
    }
    async function loadScene() {
      if (!activeSelection) return;
      if (loading || instance || destroyed) return;
      loading = true; readySignal = false;
      const myGeneration = ++generation;
      // The lightweight interior remains visible while the interactive scene prepares.
      stage.dataset.state = 'loading'; stage.setAttribute('aria-busy', 'true'); q('[data-install-load]').hidden = true; q('[data-install-status]').textContent = '';
      q('[data-install-retry]').hidden = true; q('[data-install-retry]').disabled = true;
      try {
        const moduleURL = new URL(pageData.sceneModule, win.location.href);
        if (!['http:', 'https:'].includes(moduleURL.protocol)) throw new Error('Scene module URL unavailable');
        const assets = Object.fromEntries(['interior', 'front', 'environment'].map(name => {
          const url = new URL(pageData.assets?.[name], win.location.href);
          if (!pageData.assets?.[name] || !['http:', 'https:'].includes(url.protocol)) throw new Error('Scene asset URL unavailable');
          return [name, url.href];
        }));
        const selection = activeSelection;
        if (isPoloAw(selection)) for (const name of ['poloAwInterior', 'poloAwFront', 'poloAwCarrier']) {
          const url = new URL(pageData.assets?.[name], win.location.href);
          if (!pageData.assets?.[name] || !['http:', 'https:'].includes(url.protocol)) throw new Error('Polo asset unavailable');
          assets[name] = url.href;
        }
        const cabin=pageData.modelCabins?.[selection.choice.generationId] || pageData.modelCabins?.[selection.choice.modelKey];
        if(cabin)for(const [name,field]of [['modelInterior','interior'],['modelCarrier','carrier']]){
          const url=new URL(cabin[field],win.location.href);
          if(!cabin[field]||!['http:','https:'].includes(url.protocol))throw new Error('Model scene asset unavailable');
          assets[name]=url.href;
        }
        assets.oldFront = new URL(selection.profile.imageUrl, win.location.href).href;
        const module = await import(moduleURL.href);
        if (destroyed || myGeneration !== generation) return;
        if (typeof module.createInstallScene !== 'function') throw new Error('Scene factory unavailable');
        const created = await module.createInstallScene(canvas, { assets, oldProfile: selection.profile, modelKey: selection.choice.modelKey, generationId: selection.choice.generationId, onReady: () => { if (!destroyed && myGeneration === generation) { readySignal = true; markReady(); } } });
        if (destroyed || myGeneration !== generation) { created?.dispose?.(); return; }
        if (!created || !['setProgress', 'resize', 'dispose'].every(name => typeof created[name] === 'function')) { created?.dispose?.(); throw new Error('Scene API incomplete'); }
        instance = created; sizeDirty = true; lastWidth = 0; lastHeight = 0;
        if (!reduced.matches) progress = targetProgress = fractionFromScroll();
        draw(); markReady();
      } catch (_) { if (!destroyed && myGeneration === generation) failScene(); }
    }
    function stopFrames() { if (raf) win.cancelAnimationFrame(raf); raf = 0; lastTick = null; }
    function tick(now) {
      raf = 0; if (!visible || destroyed || doc.hidden) { lastTick = null; return; }
      if (!reduced.matches) targetProgress = fractionFromScroll();
      const dt = lastTick === null ? 1 / 60 : clamp((now - lastTick) / 1000, 0, .064); lastTick = now;
      const difference = targetProgress - progress;
      progress = reduced.matches || Math.abs(difference) < .00008 ? targetProgress : progress + difference * (1 - Math.exp(-dt / .085));
      if (Math.abs(targetProgress - progress) < .00008) progress = targetProgress;
      draw();
      if (!reduced.matches && Math.abs(targetProgress - progress) >= .00008) schedule(); else lastTick = null;
    }
    function schedule() { if (visible && !destroyed && !doc.hidden && !raf) raf = win.requestAnimationFrame(tick); }
    function selectStep(index, moveFocus) {
      const next = clamp(index, 0, steps.length - 1), value = steps[next].stop;
      announceIndex = next;
      if (moveFocus) buttons[next].focus({ preventScroll: true });
      if (reduced.matches) { progress = targetProgress = value; draw(); if (!instance && !loading) loadScene(); return; }
      const stickyTop = chromeTop();
      const top = win.scrollY + root.getBoundingClientRect().top - stickyTop + value * Math.max(1, root.offsetHeight - pin.offsetHeight);
      win.scrollTo({ top: Math.max(0, top), behavior: 'smooth' }); schedule();
    }
    buttons.forEach((button, i) => {
      button.setAttribute('aria-label', 'Stap ' + (i + 1) + ': ' + steps[i].title);
      listen(button, 'click', () => selectStep(i, false));
      listen(button, 'keydown', event => {
        let next;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (i + 1) % steps.length;
        else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (i + steps.length - 1) % steps.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = steps.length - 1;
        else return;
        event.preventDefault(); selectStep(next, true);
      });
    });
    listen(q('[data-install-prev]'), 'click', () => selectStep(currentStep - 1, false));
    listen(q('[data-install-next]'), 'click', () => selectStep(currentStep + 1, false));
    listen(q('[data-install-retry]'), 'click', () => loadScene());
    listen(win, 'scroll', () => { if (!reduced.matches) { measureChrome(); updatePinPosition(); schedule(); } }, { passive: true });
    listen(win, 'resize', () => { measureChrome(); updatePinPosition(); sizeDirty = true; schedule(); }, { passive: true });
    listen(reduced, 'change', () => {
      stopFrames(); measureChrome(); updatePinPosition(); sizeDirty = true;
      progress = targetProgress = reduced.matches ? steps[Math.max(0, currentStep)].stop : fractionFromScroll();
      if (visible) draw(); else updateCopy(progress);
      schedule();
    });
    listen(doc, 'visibilitychange', () => { if (doc.hidden) stopFrames(); else { sizeDirty = true; schedule(); } });
    listen(canvas, 'webglcontextlost', event => { event.preventDefault(); generation++; stopFrames(); failScene(); });
    function syncSelection() {
      const choice = win.CarOptionsVwScreenChoice?.getCurrent?.() || null;
      // A purchasable radio may not have its own dashboard visualization yet.
      // Do not substitute another generation's cabin or alter the buy choice.
      const next = choice?.choice.sceneEnabled === false ? null : choice;
      const changed = activeSelection?.profile.id !== next?.profile.id || activeSelection?.choice.modelKey !== next?.choice.modelKey || activeSelection?.choice.generationId !== next?.choice.generationId;
      const wasPrepared = !!instance || loading;
      activeSelection = next;
      root.hidden = !next;
      if (next) {
        root.dataset.radioId = next.profile.id;
        baseSteps.forEach((step, i) => Object.assign(steps[i], step));
        steps[0].title = 'Jouw huidige radio.';
        steps[0].body = next.choice.radioLabel + ' voor je Volkswagen ' + next.choice.modelLabel.split(' - ')[0] + '. Scroll verder en bekijk de vervanging.';
        steps[1].title = next.profile.label + ' eruit.';
        steps[1].body = 'Maak het paneel en de bevestiging los, trek de radio naar voren en maak de aansluitingen los. Volg de handleiding van jouw uitvoering.';
        if (next.choice.generationId === 'vw-golf-6') {
          steps[1].body = 'Klik de omlijsting voorzichtig los en draai de vier schroeven uit. Trek de radio naar voren en maak de stekkers los. Volg de handleiding.';
          steps[3].body = 'Schuif de aangesloten radio terug, draai de vier schroeven vast en klik de omlijsting terug. Verbind je telefoon en controleer beeld en geluid.';
        }
        if (isPoloAw(next)) {
          steps[1].body = 'Maak de dashboardlijst voorzichtig los en ontgrendel de radio met radiosleutels. Trek hem naar voren en maak de stekkers los. Volg de handleiding.';
          steps[3].title = 'CarPlay en Android Auto.';
          steps[3].body = 'Schuif de aangesloten radio terug tot de klemmen vastzitten. Plaats de lijst terug en verbind je telefoon met de USB-poort.';
        }
        const poster=q('[data-install-poster]');poster.src=isPoloAw(next) ? pageData.assets.poloAwInterior : next.profile.imageUrl;poster.alt=isPoloAw(next) ? 'Jouw huidige radio in het Polo AW-dashboard' : 'Jouw gekozen radio: '+next.profile.label;
      } else { delete root.dataset.radioId; }
      currentStep = -1; announceIndex = null; q('[data-install-announcement]').textContent = '';
      if (changed) {
        generation++; stopFrames(); releaseInstance(); loading=false;readySignal=false;
        stage.dataset.state='idle';stage.classList.add('is-personal-loading');stage.setAttribute('aria-busy',String(!!next));
        q('[data-install-poster]').removeAttribute('aria-hidden');
        delete canvas.dataset.dashboard;delete canvas.dataset.mounting;delete canvas.dataset.oldRadio;delete canvas.dataset.oldKnobs;delete canvas.dataset.oldPhoto;
        if(next && (visible || wasPrepared))loadScene();
      }
      sizeDirty=true;measureChrome();updatePinPosition();updateCopy(progress);schedule();
    }
    listen(doc, 'co:vwscreen:choice', syncSelection);
    listen(win, 'pageshow', () => { measureChrome(); updatePinPosition(); sizeDirty = true; schedule(); });
    listen(win, 'pagehide', event => { if (event.persisted) stopFrames(); else root.coVwScreenDestroy(); });
    if ('IntersectionObserver' in win) {
      observer = new win.IntersectionObserver(entries => {
        visible = entries.some(entry => entry.isIntersecting);
        root.classList.toggle('is-visible', visible);
        if (visible) { measureChrome(); updatePinPosition(); sizeDirty = true; if (!instance && !loading && stage.dataset.state !== 'error') loadScene(); schedule(); }
        else stopFrames();
      }, { threshold: 0 });
      observer.observe(root);
      if (!win.navigator.connection?.saveData) {
        // Prepare ahead of the viewport, but only animate while actually visible.
        preloadObserver = new win.IntersectionObserver(entries => {
          if (!entries.some(entry => entry.isIntersecting) || doc.hidden || destroyed) return;
          preloadObserver.disconnect();
          if (!instance && !loading && stage.dataset.state !== 'error') loadScene();
        }, { rootMargin: '1200px 0px', threshold: 0 });
        preloadObserver.observe(root);
      }
    } else { visible = true; root.classList.add('is-visible'); loadScene(); }
    if ('ResizeObserver' in win) {
      resizeObserver = new win.ResizeObserver(() => { measureChrome(); updatePinPosition(); sizeDirty = true; schedule(); });
      for (const element of [stage, doc.querySelector(headerSelector), doc.querySelector(barSelector)]) if (element) resizeObserver.observe(element);
    }
    syncSelection(); measureChrome(); updatePinPosition(); updateCopy(0);
    root.coVwScreenDestroy = () => { if (destroyed) return; destroyed = true; generation++; stopFrames(); observer?.disconnect(); preloadObserver?.disconnect(); resizeObserver?.disconnect(); removers.forEach(remove => remove()); releaseInstance(); root.classList.remove('is-visible'); delete root.dataset.pinState; delete root.dataset.installMounted; };
  }
  function initialize(scope = document) {
    const roots = [...scope.querySelectorAll('[data-co-vwscreen-scene]')];
    if (scope.matches?.('[data-co-vwscreen-scene]')) roots.unshift(scope);
    roots.forEach(root => {
      let data = {};
      try { data = JSON.parse(root.querySelector('[data-co-vwscreen-config]').textContent); } catch (_) {}
      mount(root, data);
    });
  }
  window.CarOptionsVwScreen = { initialize };
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-co-vwscreen-scene]').forEach(root => root.coVwScreenDestroy?.());
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true }); else initialize();
})();
